import styled, { css } from 'styled-components';

// Import components
import { Heading } from 'components/elements';

// Import styles utilities
import { customMinResponsive, size, flex } from 'components/styles';

export const Content = styled.div`
	position: relative;
	margin-top: 2.9rem;
	min-height: 20rem;

	${({ isHistoryAvailable }) =>
		isHistoryAvailable
			? css`
					min-width: 65rem;
			  `
			: css`
					width: 100%;
			  `}
`;

export const Info = styled.p`
	color: ${({ theme }) => theme.grayMedium};
	text-align: center;
`;

export const Top = styled.div`
	${flex({ jc: 'space-between' })}
	flex: 1;
	min-height: 4.4rem;

	${({ wrapContent }) =>
		wrapContent &&
		css`
			${flex({ fd: 'column', ai: 'flex-end' })}
			padding-bottom: 0.8rem;
			border-bottom: 1px solid ${({ theme: { user } }) => user.line};
			color: red !important;

			> :first-child {
				margin-bottom: 1.5rem;
				align-self: flex-start;
			}

			${customMinResponsive(
				size.xsmall,
				css`
					${flex({ jc: 'space-between', ai: 'flex-start' })}

					> :firs-child {
						margin-bottom: 0;
					}
				`
			)}
		`}
`;

export const HeadingStyled = styled(Heading.First)`
	text-align: center;
	font-size: ${({ theme: { user } }) => user.font.heading.base}rem;
	font-weight: ${({ theme }) => theme.font.medium};
	color: ${({ theme: { user } }) => user.topHeading};
	margin: 0 3rem 0 0;
`;
